import { History } from 'history';

let history: History;

export const goTo = (path: string) => {
	if (history) {
		history.push(path);
	} else {
		console.error('History object is not initialized.');
	}
};
